export const removeObjectProperties = (obj, ...properties) => {
  const newObject = { ...obj };

  properties.forEach((property) => {
    delete newObject[property];
  });

  return newObject;
};
